import type { AppContext } from '@application/context/AppContext';
import { fetchAndApplyEntitlements } from '@application/licence/EntitlementFetchService';
import { isLocalOfflineMode, isRemoteMultiStationMode } from '@infra/licence/DataModeResolver';
import { logger } from '@infra/telemetry/Logger';

/** Recharge modules + profils depuis le serveur si Internet disponible (tous modes). */
export async function syncEntitlementsWhenOnline(ctx: AppContext): Promise<boolean> {
  const runtime = ctx.getLicenceRuntime();
  if (!runtime?.getState().valid) return false;
  const ok = await fetchAndApplyEntitlements(ctx, runtime);
  logger.info({ event: 'entitlement_sync_online', ok, mode: ctx.getLockedDataMode() });
  return ok;
}

/** Remote : recharge modules + profils à chaque connexion (sans renouveler le certificat). */
export async function syncEntitlementsOnRemoteLogin(ctx: AppContext): Promise<void> {
  if (!isRemoteMultiStationMode(ctx.getLockedDataMode())) return;
  await syncEntitlementsWhenOnline(ctx);
}

/** Local : recharge modules + profils après synchro métier quand Internet est disponible. */
export async function syncEntitlementsAfterLocalSync(ctx: AppContext): Promise<void> {
  const runtime = ctx.getLicenceRuntime();
  if (!runtime || !isLocalOfflineMode(ctx.getLockedDataMode())) return;
  const ok = await fetchAndApplyEntitlements(ctx, runtime);
  logger.info({ event: 'entitlement_sync_local_sync', ok });
}
